import { TrendingUp, TrendingDown } from "lucide-react";

export default function StatCard({
  title,
  value,
  sub,
  icon: Icon,
  color = "violet",
  trend,
  trendValue,
}) {
  const colorMap = {
    violet: {
      bg: "bg-violet-500/10",
      icon: "text-violet-400",
      border: "border-violet-500/20",
    },
    emerald: {
      bg: "bg-emerald-500/10",
      icon: "text-emerald-400",
      border: "border-emerald-500/20",
    },
    amber: {
      bg: "bg-amber-500/10",
      icon: "text-amber-400",
      border: "border-amber-500/20",
    },
    blue: {
      bg: "bg-blue-500/10",
      icon: "text-blue-400",
      border: "border-blue-500/20",
    },
    rose: {
      bg: "bg-rose-500/10",
      icon: "text-rose-400",
      border: "border-rose-500/20",
    },
  };
  const c = colorMap[color] || colorMap.violet;

  return (
    <div className="stat-card group">
      <div className="flex items-start justify-between">
        <div className={`p-2.5 rounded-xl ${c.bg} border ${c.border}`}>
          <Icon size={20} className={c.icon} />
        </div>
        {trendValue != null && (
          <div
            className={`flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-lg ${
              trend === "up"
                ? "bg-emerald-500/10 text-emerald-400"
                : "bg-rose-500/10 text-rose-400"
            }`}>
            {trend === "up" ? (
              <TrendingUp size={12} />
            ) : (
              <TrendingDown size={12} />
            )}
            {trendValue}
          </div>
        )}
      </div>
      <div className="mt-4">
        <p className="text-2xl font-bold text-gray-900 dark:text-gray-100 tracking-tight">
          {value}
        </p>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mt-0.5">{title}</p>
        {sub && <p className="text-xs text-gray-500 dark:text-gray-600 mt-1">{sub}</p>}
      </div>
    </div>
  );
}
